
    <div class="retry-error" [ngClass]="{open: slideshow.showRetryMessage}">We're having trouble connecting. Please try again <button type="button" (click)="slideshow.retry.emit(true)">RETRY</button></div>
    <div id="top-bar" fxLayout="row" fxLayoutAlign="center">
        <div id="status-bar" class="mat-publish" *ngIf="slideshow.assignment && slideshow.assignment.published">
            <span class="primary">
                <span>{{slideshow.assignment.status == 'imported' ? 'Imported from:' : 'Primary article is live at the following link:'}}</span> <a *ngFor="let site of slideshow.assignment.sites | sites : true;" href="{{site.permalink}}" target="_blank">{{site.samplePermalink ? site.samplePermalink : site.permalink}}</a>
            </span>
            <span class="other" *ngIf="hasPublishedSites()">
                <span>Article is also live on these properties: </span>
                <span class="sites">
                    <a *ngFor="let site of slideshow.assignment.sites | sites;" href="{{site.permalink}}" title="{{site.domain}}" target="_blank" class="site-{{site.abbreviation}} mini">{{site.abbreviation}}</a>
                </span>
            </span>
        </div>

        <!-- assignment title -->
        <section fxFlex id="assignment-title" *ngIf="slideshow.assignment">
            <input 
                matInput 
                name="slideshowAssignmentTitle"
                autocomplete="slideshowAssignmentTitle"
                id="slideshowAssignmentTitle{{slideshowAssignmentTitle}}"
                class="h2" 
                placeholder="Assignment Title" 
                [(ngModel)]="slideshow.assignment.title"
                [attr.title]="slideshow.assignment.title"
                [disabled]="slideshow.locked || user?.role == 'writer' || user?.role == 'contributor'">

            <span class="status">
                <span class="status-dot mat-{{slideshow.assignment.status}}"></span> <span class="status-text">
                    {{slideshow.assignment.cloneMaster && slideshow.assignment.status == 'publish' ? 'Copy ' : ''}} {{ statuses[slideshow.assignment.status] }}
                </span>
                <span class="status-text-date" *ngIf="slideshow.assignment.status == 'future' || slideshow.assignment.status == 'publish'">
                    ({{this.utils.convertUtcDateToLocal(slideshow.assignment.date).toLocaleString()}})
                </span>
            </span>

        </section>

        <!-- publish actions -->
        <section id="actions" #actions>
            <div *ngIf="!slideshow.locked; else grabber">
                
                <!-- 3-dot menu button -->
                <button 
                    type="button"
                    *ngIf="showAdditionalMenu"
                    class="editor-menu-toggle"
                    mat-icon-button 
                    [matMenuTriggerFor]="dropdownMenu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <!-- 3-dot menu -->
                <mat-menu 
                    class="editor-menu"
                    #dropdownMenu="matMenu"
                    [overlapTrigger]="false"
                    xPosition="before"
                    yPosition="below">
                    <!-- revision request button -->
                    <button 
                        mat-menu-item
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="maybeAddComment()">
                        Request Revision
                    </button>

                    <!-- revision request button -->
                    <button 
                        mat-menu-item
                        *ngIf="slideshow.quiz !== true"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="slideshow.removeAllTeasers()"
                        >
                        Remove All Teasers
                    </button>

                    <!-- Create Syndication Slideshow button -->
                    <button 
                        mat-menu-item
                        *ngIf="slideshow.quiz == true"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="createSlideshowFromQuiz()">
                        Create Syndication Slideshow
                    </button>

                    <!-- submit to editor button -->
                    <button 
                        mat-menu-item
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="slideshow.submit()">
                        Submit to Editor
                    </button>

                    <!-- publish ready button -->
                    <button 
                        mat-menu-item
                        *ngIf="showPublishReadyBtn === true"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="slideshow.maybeSetStatus('publish_ready')">
                        Ready to Publish
                    </button>

                    <!-- refresh mobile images button -->
                    <button 
                        mat-menu-item
                        *ngIf="slideshow.quiz !== true"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="imagesService.resetMobileSizeAll()">
                        Refresh Mobile Images
                    </button>

                    <!-- refresh desktop images button -->
                    <button 
                        mat-menu-item
                        *ngIf="slideshow.quiz !== true"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="imagesService.resetDesktopSizeAll()">
                        Refresh Desktop Images
                    </button>
                    
                    <!-- reset mobile images button -->
                    <button 
                        mat-menu-item
                        *ngIf="slideshow.quiz !== true"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="imagesService.resetMobileSizeAll(false)">
                        Reset Mobile Images
                    </button>

                    <!-- reset desktop images button -->
                    <button 
                        mat-menu-item
                        *ngIf="slideshow.quiz !== true"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="imagesService.resetDesktopSizeAll(false)">
                        Reset Desktop Images
                    </button>

                    <!-- delete multiple button -->
                    <button 
                        mat-menu-item
                        *ngIf="permissionsService.userHasPermission(Permissions.DeleteSlides)"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="maybeDeleteMultiple()">
                        Delete Multiple Slides
                    </button>

                    <!-- delete button -->
                    <button 
                        mat-menu-item
                        *ngIf="permissionsService.userHasPermission(Permissions.DeleteAssignment)"
                        [disabled]="slideshow.saving || slideshow.autosaving || slideshow.publishing"
                        (click)="delete()">
                        Delete
                    </button>
                </mat-menu>
                
                <!-- save button -->
                <div class="button-wrap">
                        <button 
                            class="button clear"
                            [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                            (click)="slideshow.saveSlides(false, false)">
                            Save
                        </button>
                        <span class="save-message" *ngIf="(slideshow.saving || slideshow.autosaving) && !slideshow.publishing && !slideshow.retrying">Saving</span>
                        <span class="save-message" *ngIf="assignments.deleting === true && !slideshow.retrying">Deleting</span>
                        <span class="save-message" *ngIf="slideshow.retrying && !slideshow.publishing">Retrying...</span>
                    </div>
                <div class="button-wrap" *ngIf="slideshow.assignment.published && slideshow.assignment.status == 'future' && permissionsService.userHasPermission(Permissions.PublishAssignment)" >
                    <button class="button" [matMenuTriggerFor]="UpdateMenu">Update <mat-icon>arrow_drop_down</mat-icon></button>
                    <mat-menu #UpdateMenu="matMenu" yPosition="below">
                        <button
                            mat-menu-item
                            [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                            (click)="slideshow.maybePublish(false)">
                                Publish Now
                        </button>
                        <button 
                            mat-menu-item
                            [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                            (click)="slideshow.maybePublish(true)">
                                Update Schedule
                        </button>
                    </mat-menu>
                </div>

                <!-- writer, contributor submit -->
                <div class="button-wrap" *ngIf="slideshow.assignment.pageAddWriter != user.id && permissionsService.userHasPermission(Permissions.SubmitAssignment)" >
                    <button 
                        class="button" 
                        [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                        (click)="slideshow.submit()">
                        Submit
                    </button>
                </div>

                <!-- page additions submit -->
                <div class="button-wrap" *ngIf="slideshow.assignment.pageAddWriter == user.id" >
                    <button 
                        *ngIf="!slideshow.assignment.published"
                        class="button" 
                        [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting "
                        (click)="slideshow.submit()">
                        Submit
                    </button>
                    <button 
                        *ngIf="slideshow.assignment.published"
                        class="button"
                        [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                        (click)="slideshow.maybePublish(false)">
                            {{slideshow.assignment.published ? 'Update' : 'Publish'}}
                    </button>
                </div>

                <!-- editor, dmc, administrator submit -->
                <div 
                    class="button-wrap" 
                    *ngIf="slideshow.assignment.pageAddWriter != user.id"
                >
                    <button 
                        *ngIf="!slideshow.assignment.published && permissionsService.userHasPermission(Permissions.PublishAssignment)" 
                        class="button" 
                        [matMenuTriggerFor]="publishMenu"
                    >Publish <mat-icon>arrow_drop_down</mat-icon></button>
                    <mat-menu #publishMenu="matMenu" yPosition="below">
                        <button
                            mat-menu-item
                            [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                            (click)="slideshow.maybePublish(false)">
                                Publish Now
                        </button>
                        <button 
                            mat-menu-item
                            [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                            (click)="slideshow.maybePublish(true)">
                                Schedule
                        </button>
                    </mat-menu>
                    
                    <button 
                        class="button"
                        *ngIf="slideshow.assignment.published && slideshow.assignment.status !== 'future' && permissionsService.userHasPermission(Permissions.UpdateAssignment)"
                        [disabled]="slideshow.saving || slideshow.publishing || assignments.deleting"
                        (click)="slideshow.maybePublish(false)">
                            Update
                    </button>
                    <span class="save-message" *ngIf="slideshow.publishing && !slideshow.retrying">Publishing</span>
                    <span class="save-message" *ngIf="slideshow.publishing && slideshow.retrying">Retrying...</span>
                </div>
                
                
            </div>
            <ng-template #grabber>
                <div class="button-wrap" *ngIf="slideshow.assignment">
                    <button class="button" [ngClass]="{'disabled': assignments.maybeLocked(slideshow.assignment.lock)}" (click)="slideshow.grab(actions)">{{assignments.maybeLocked(slideshow.assignment.lock) ? 'Take Over' : 'Edit'}}</button>
                    <span class="save-message" *ngIf="assignments.maybeLocked(slideshow.assignment.lock)" [attr.title]="assignments.getLockText(slideshow.assignment.lock)">{{assignments.getLockText(slideshow.assignment.lock)}}</span>
                </div>
            </ng-template>
        </section>

    </div>

    <!-- tabs -->
    <mat-tab-group 
        id="tabs" 
        class="tabs" 
        #group 
        [dynamicHeight]="true" 
        [ngClass]="{'writing-error': slideshow.writingTabError, 'meta-error': slideshow.metaTabError, 'ads-error': slideshow.adsTabError}"
        (selectedTabChange)="tabChanged($event)"
        (animationDone)="animationComplete($event)">
        <mat-tab label="Writing">
            <mat-drawer-container class="slide-drawer-container" hasBackdrop="true">
                <mat-drawer class="slide-drawer" #slideDrawer mode="over">
                    <slidenavpanel id="slide-nav-panel" (deleteMultiple)="deleteMultiple($event)" [slideDrawer]="slideDrawer"></slidenavpanel>
                </mat-drawer>
                <mat-drawer-content>
                    <writing-component *ngIf="!group.selectedIndex || group.selectedIndex == 0" class="cf" [animationComplete]="writingAnimationComplete" [slideDrawer]="slideDrawer"></writing-component>
                </mat-drawer-content>
            </mat-drawer-container>
        </mat-tab>
        <mat-tab label="Details">
           <details-component id="details" *ngIf="group.selectedIndex == 1" class="container cf"></details-component>
        </mat-tab> 
        <mat-tab label="Meta" class="meta-tab">
           <meta-component id="meta" *ngIf="group.selectedIndex == 2" class="container cf"></meta-component>
        </mat-tab> 
        <mat-tab label="Preview">
            <preview-component *ngIf="group.selectedIndex == 3" class="cf" [animationComplete]="previewAnimationComplete"></preview-component>
        </mat-tab>
        <mat-tab label="Ads">
            <ads-component id="ads" *ngIf="group.selectedIndex == 4" class="container cf"></ads-component>
        </mat-tab>
    </mat-tab-group>

    <!-- upload preview -->
    <div id="upload-preview" [ngClass]="{open: trayOpen, processing: imagesService.uploadInProgress}">
        <div class="title" (click)="toggle()">
            <span class="upload-count faded">{{imagesService.progressCount}}/{{imagesService.progressTotal}}</span>
            <span class="progress active">
                <span class="bar" [style.width]="imagesService.progress + '%'"></span>
            </span>
        </div>
        <button class="button" (click)="imagesService.cancelUploading()">Cancel</button>
        <ul>
            <li *ngFor="let img of imagesService.tempImages; trackBy: utils.trackByIndex" id="{{img.tempId}}">
                <span class="filename">{{img.name}}</span>
                <span class="image" 
                    [ngStyle]="{
                        'background-attachment' : img.sizes?.thumbnail ? 'url(\'' + img.sizes.thumbnail.url + '\')' : 'url(\'wp-content/themes/swarm/app/assets/images/loading.gif\')'
                    }">
                </span>
            </li>
        </ul>
    </div>
